/**
 * Formats a date for use in an HTML input element of type 'date'
 * @param {string|Date} date - The date to format
 * @returns {string} The formatted date string in YYYY-MM-DD format, or empty string if invalid
 */
export function toDateInputValue(date) {
    if (!date) return '';
    if (/^\d{4}-\d{2}-\d{2}$/.test(date)) return date;
    const d = new Date(date);
    if (isNaN(d)) return '';
    return d.toISOString().slice(0, 10);
} 